/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["ui-user-permissions[_ngcontent-%COMP%]{display:block;margin-top:10px}"];
export { styles as styles };
